import type { AppContext } from "@gamedev-web/gamedev-sdk-core";
import { createAction } from "./internal/platformActionCreators";
import { Scope } from "./scopes";

export enum AppContextActions {
  SET_DEVICE_ID = "@appContext/SET_DEVICE_ID",
  SET_APP_CONTEXT = "@appContext/SET_APP_CONTEXT",
  SET_IS_PREVIEW_MODE = "@appContext/SET_IS_PREVIEW_MODE",
  SET_IS_REACT_DOM_HYDRATING = "@appContext/SET_IS_REACT_DOM_HYDRATING",
  SET_BOOTSTRAP_INITIALIZED = "@appContext/SET_BOOTSTRAP_INITIALIZED",
}

export const appContextActions = {
  setAppContext: createAction(
    AppContextActions.SET_APP_CONTEXT,
    Scope.AppContext,
    (appContext: AppContext) => ({
      appContext,
    })
  ),
  setIsPreviewMode: createAction(
    AppContextActions.SET_IS_PREVIEW_MODE,
    Scope.AppContext,
    (isPreviewMode: boolean) => ({
      isPreviewMode,
    })
  ),
  setIsReactDomHydrating: createAction(
    AppContextActions.SET_IS_REACT_DOM_HYDRATING,
    Scope.AppContext,
    (isReactDomHydrating: boolean) => ({
      isReactDomHydrating,
    })
  ),
  setDeviceId: createAction(
    AppContextActions.SET_DEVICE_ID,
    Scope.AppContext,
    (deviceId: string) => ({
      deviceId,
    })
  ),
  setBootstrapInitialized: createAction(
    AppContextActions.SET_BOOTSTRAP_INITIALIZED,
    Scope.AppContext,
    () => ({})
  ),
};
